const convertBoolToBinary = (bool) => {
  if (bool === null || bool === undefined) return ''
  return +bool
}

export default convertBoolToBinary
